import React, { useState } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Card, Row, Col, Button, Input } from 'reactstrap';
import CreateProactiveNotificationService from '../../../../../../../Service/OPSServices/ProactiveMonitoringServices/CreateProactiveNotificationService';
import DisplayObject from './DisplayObject';

function ProactiveMonitoringNotifications(props) {

  // 1. Initialize as arrays to support multiple selection
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [selectedAlerts, setSelectedAlerts] = useState([]);
  const [searchText, setSearchText] = useState('');

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const filteredData = props.notificationsData.filter((item) =>
    Object.values(item).join(' ').toLowerCase().includes(searchText.toLowerCase())
  );

  const handleCreateNotificate = () => {
    console.log(selectedRowData);
    
    // Payload now contains an array of selected items
    let payload = {
      notificationData: selectedRowData 
    }

    CreateProactiveNotificationService(props.token, payload).then((res) => {
      if (res) {
        console.log(res);
        window.location.reload();
      }
    })
  }

  // 2. Updated Selection Logic (Multi-select + Disable Created)
  const handleSelect = (row) => {
    // Security Check: Do not allow action if status is 'Created'
    if (row.status === 'Created') return;

    if (selectedAlerts.includes(row.id)) {
      // --- UNCHECK (REMOVE) ---
      // Filter out the ID from the selectedAlerts array
      setSelectedAlerts(prev => prev.filter(id => id !== row.id));
      
      // Filter out the object from selectedRowData
      setSelectedRowData(prev => prev.filter(item => item.id !== row.id));
    } else {
      // Add the ID to selectedAlerts
      setSelectedAlerts(prev => [...prev, row.id]);
      
      // Add the full object to selectedRowData
      setSelectedRowData(prev => [...prev, row]);
    }
  };

  const columns = [
    ...(props.activeTab !== "complete"
      ? [
        {
          Header: "Select",
          accessor: "type",
          Cell: (cellInfo) => (
            <div className="d-flex justify-content-center w-100">
              <input
                // Checked if ID is in the array
                checked={selectedAlerts.includes(cellInfo.original.id)}
                // Disabled if status is 'Created'
                disabled={cellInfo.original.status === "Created"}
                onChange={() => handleSelect(cellInfo.original)}
                type='checkbox'
                style={{ cursor: cellInfo.original.status === "Created" ? 'not-allowed' : 'pointer' }}
              />
            </div>
          ),
          width: 65,
        },
      ]
      : []),
    {
      Header: "Store Name",
      accessor: "store_name",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center ml-1 w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
        </div>
      ),

    },
    // {
    //   Header: "IntegerId",
    //   accessor: "integerid",
    //   Cell: (cellInfo) => (
    //     <div className="d-flex justify-content-center w-100">
    //       <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
    //     </div>
    //   ),

    // },
    {
      Header: "Asin",
      accessor: "asin",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
        </div>
      ),

    },
    {
      Header: "Type",
      accessor: "type",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Old Value",
      accessor: "old_value",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table"><DisplayObject data={cellInfo.value} /></p>
        </div>
      ),
    },
    {
      Header: "New Value",
      accessor: "new_value",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table"><DisplayObject data={cellInfo.value} /></p>
        </div>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
    },

    {
      Header: "Created At",
      accessor: "created_at",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
        </div>
      ),
    },
  ];

  return (
    <>
      <Col md={12} className="mt-4">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="m-0">
            <b>NOTIFICATIONS</b>
          </h5>
          <div className="d-flex justify-content-end">
            <Input
              type="text"
              placeholder="Search Notifications..."
              value={searchText}
              onChange={handleSearchChange}
              className={`${props.activeTab === "complete" ? "w-100" : "w-100 mr-4"}`}
            />
            {props.activeTab !== "complete" && (
              <Button
                onClick={handleCreateNotificate}
                className="btn-background-color-Proceed-gallery hidden-btn w-75"
                // 3. Disable button if no items selected
                disabled={selectedRowData.length === 0}
              >
                Create Notification
              </Button>
            )}
          </div>
        </div>
      </Col>
      <Col md={12}>
        <ReactTable
          data={filteredData}
          columns={columns}
          className="-fixed -highlight -striped mt-2"
          getTheadProps={() => {
            return {
              style: {
                overflowY: "hidden",
                background: "#B1FA63",
                color: "#243837",
              },
            };
          }}
          defaultPageSize={5}
          noDataText={"No Data Found."}
        />

      </Col>
    </>
  )
}

const mapStateToProps = state => ({
  token: state.loggedUser.token,
});

export default connect(mapStateToProps)(ProactiveMonitoringNotifications);